import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { CommonModule } from '@angular/common';
import { AuditsData } from '../../../models';
import { LoaderComponent } from '../loader/loader.component';

@Component({
  selector: 'app-audit-modal',
  standalone: true,
  imports: [CommonModule, DialogModule, LoaderComponent],
  templateUrl: './audit-modal.component.html',
  styleUrl: './audit-modal.component.scss',
})
export class AuditModalComponent implements OnInit, OnChanges {
  @Input() visible: boolean = false;
  // @Input() title = 'Dialog'; // Dynamic header
  // @Input() width = '50vw'; // Customizable width
  // @Input() closable = true; // Show/hide close icon
  @Input() dismissableMask = true;
  @Input() logs: AuditsData[] = [];
  @Input() row: any;
  @Input() loading: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Output() close = new EventEmitter<void>();

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  onClose() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.close.emit();
  }
}
